import { render } from "./ProductsDashboard.vue?vue&type=template&id=2ab62599"
import script from "./ProductsDashboard.vue?vue&type=script&lang=js"
export * from "./ProductsDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/nikrahan-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__